import * as React from 'react';
import './AuthorityLabel.css';

interface IAuthorityLabelProps {
  authority: Authority;
}

/**
 * 利用者の権限の段階。値はサーバーの権限の段階（authority.level）と同じで、大きいほど多くの画面を扱える。
 */
export enum Authority {
  Normal = 1,
  MasterAdmin = 2,
  Admin = 3,
  SuperAdmin = 99,
}

/**
 * 権限の段階を表示名にする。表示名はユーザー編集画面の権限の選択肢と同じ表記にする。
 */
export function getAuthorityName(level: number): string {
  if (level >= Authority.SuperAdmin) {
    return 'スーパー管理者';
  }
  if (level >= Authority.Admin) {
    return '管理者';
  }
  if (level >= Authority.MasterAdmin) {
    return 'マスター編集者';
  }
  return '作業者';
}

/**
 * 権限の段階ごとの色のクラス。特別な権限を持たない作業者は灰色の控えめな表示にする。
 */
function getAuthorityClassName(level: number): string {
  if (level >= Authority.SuperAdmin) {
    return 'AuthorityLabel AuthorityLabel-super_admin';
  }
  if (level >= Authority.Admin) {
    return 'AuthorityLabel AuthorityLabel-admin';
  }
  if (level >= Authority.MasterAdmin) {
    return 'AuthorityLabel AuthorityLabel-master_admin';
  }
  return 'AuthorityLabel AuthorityLabel-normal';
}

/**
 * 権限の段階を、一覧の表などに出すラベルにする。表示名はヘッダーのユーザーメニューと同じ getAuthorityName の表記を使う。
 */
export const AuthorityLabel: React.FC<IAuthorityLabelProps> = function (props) {
  return <span className={getAuthorityClassName(props.authority)}>{getAuthorityName(props.authority)}</span>;
};
